var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#9DED5C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.387 14.5676L19.9514 18.9549L27.1428 19.6611L13.2432 31.0237L16.0508 34.4325L29.9505 23.0699L29.2416 30.2346L33.6451 30.6686L35.0945 16.0116L20.387 14.5676Z",
    fill: "#105079"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8514,
    height: 19.8649,
    fill: "white",
    transform: "translate(13.2432 14.5676)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2256c17df3c3f9db1f46768a3f5bb2d6.svg";
export { ForwardRef as ReactComponent };